import React from 'react';
import { Box,  Typography, Modal } from '@mui/material';
import StoryEditor from './storyEditor';


function storyEditorModal(props){

const style={
    position: 'absolute',
    top: '50%',
    left: '53%',
    transform: 'translate(-50%, -50%)',
    width: 480,
    maxHeight:"90%",
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    };

const handleClose=()=>{props.setModalOpen(false)}



return(
<Modal
  open={props.modalOpen}
  onClose={handleClose}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
>
  <Box sx={style}>
   
    <Typography variant='subtext3'>Edit the patient's history if necessary</Typography>
   <Box sx={{m:2}}>
   <StoryEditor handleClose={handleClose}/> 
  </Box>
  </Box>
</Modal>)

}

export default storyEditorModal